import { Injectable, OnDestroy } from '@angular/core';
import { GlobalMessageService, HttpErrorHandler, Priority } from '@spartacus/core';
import { HttpErrorResponse, HttpRequest } from '@angular/common/http';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { ConfigurationService } from '../services';

@Injectable({
  providedIn: 'root'
})
export class InternalServerErrorHandler extends HttpErrorHandler implements OnDestroy {
  protected readonly destroy$: Subject<void> = new Subject();
  constructor(
    globalMessageService: GlobalMessageService,
    private router: Router,
    private configService: ConfigurationService
  ) {
    super(globalMessageService);
  }

  responseStatus = 500;

  handleError(request: HttpRequest<any>, errorResponse: HttpErrorResponse): void {
    if (errorResponse.message.includes('search')) {
      return;
    }
    this.configService
      .getConfig()
      .pipe(takeUntil(this.destroy$))
      .subscribe((config) => {
        if (!request.url.startsWith(config.myAccount.baseUrl)) {
          // TODO-EL: voir si cette route existe bien
          this.router.navigate(['/error/500']);
        }
      });
  }

  getPriority(): Priority {
    return Priority.NORMAL;
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
